import { all, fork } from 'redux-saga/effects';

import * as authSaga from './auth';
import * as ssoSaga from './sso';
import * as validateSaga from './validate';
import * as guestSaga from './guest';
import * as healthCheckSaga from './healthCheck';
import * as adminSaga from './admin/admin';
import * as networksSaga from './admin/network';
import * as usersSaga from './admin/user';

export default function* rootSaga() {
  yield all(
    [
      ...Object.values(authSaga),
      ...Object.values(ssoSaga),
      ...Object.values(validateSaga),
      ...Object.values(guestSaga),
      ...Object.values(healthCheckSaga),
      ...Object.values(adminSaga),
      ...Object.values(networksSaga),
      ...Object.values(usersSaga),
    ].map(fork)
  );
}
